import React from 'react';

import { useStore } from '@vromo/mobx-react';
import { capitalize } from "lodash";
import { EntityList, PolicyRule } from "@vromo/models";

import { convertDistanceForCurrentSetting } from "@vromo/utils/convertDistance";
import Pill from '@vromo/ui/components/Pill';
import Flex from '@vromo/ui/components/Flex';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { conditionDefinitions, pillConfigurations } from "../Condition";
import { RootStore } from '../../stores/RootStore';
import { RuleControl, RuleTab } from './styled';
import { observer } from 'mobx-react-lite';
import { buildDynamicLabel } from '../../../../../common-qa-labels/utils';
import { qaLabelAutodispatcher } from '../../../../../common-qa-labels/autodispatcher';

interface Props {
  deleteRule: (rule: PolicyRule) => void
  editRule: (rule: PolicyRule, index: number, isNew: boolean) => void;
  rules: EntityList<PolicyRule>,
  teams: Array<{ label: string | null; value: number | boolean | null; }>;
}

const Rules = observer<Props>(function Rules({ rules, teams, editRule, deleteRule }) {
  const { viewStore } = useStore<RootStore>('rootStore');

  const convertDistance = (r: number): string => convertDistanceForCurrentSetting(r, viewStore.imperialUnits);

  
  return (
    <>
      {rules?.items.map((rule, ix) => {
        const conditionDescriptions = [
          {
            value: capitalize(rule.mode as string),
            key: 'mode',
            ...pillConfigurations.get('mode'),
          },
          {
            key: 'team',
            value: teams.find((to) => to.value === rule.team)?.label || 'Unknown Group',
            ...pillConfigurations.get('team'),
          },
        ]

        conditionDescriptions.push(...[
          ...rule.fieldDescriptions,
          ...rule.stacking?.fieldDescriptions || [],
        ].map(item => {
          const { value, condition } = item;
          const def = conditionDefinitions.get(condition)!;
          const { type, description, icon, color, tag } = def;
          const boundTag = tag.bind(def);

          let newValue = value
          if (type === 'distance') newValue = convertDistance(Number(value));

          return {
            color,
            description,
            icon,
            key: condition,
            value: boundTag(newValue),
          }
        }));

        return (
          <RuleTab data-testid={buildDynamicLabel(qaLabelAutodispatcher.autoDispatcherModal.ruleTab,ix)} key={rule.id || ix}>
            <Flex horizontal='between' vertical='middle'>
              <Flex
                horizontal="left"
                style={{
                  flex: 1,
                  flexWrap: 'wrap',
                  marginRight: 20
                }}
                direction="row"
              >
                {conditionDescriptions.map(({ key, description, icon, value, color}) => (
                  <Pill
                    color={color!}
                    description={((value ?? description) || '').toString()}
                    icon={icon}
                    key={key}
                    title={description}
                  />
                ))}
              </Flex>
              <RuleControl>
                <FontAwesome data-testid={buildDynamicLabel(qaLabelAutodispatcher.autoDispatcherModal.editBtn,ix)} icon="edit" onClick={() => editRule(rule, ix, false)} />
                <FontAwesome data-testid={buildDynamicLabel(qaLabelAutodispatcher.autoDispatcherModal.trashBtn,ix)} icon="trash-alt" onClick={() => deleteRule(rule)} />
              </RuleControl>
            </Flex>
          </RuleTab>
        );
      })
      }
    </>
)
});

export default Rules;
